/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available statuses choose from.
 */
export type ConnectedAudiologistChainNumberStatus =
  (typeof ConnectedAudiologistChainNumberStatus)[keyof typeof ConnectedAudiologistChainNumberStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectedAudiologistChainNumberStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;
